export default __webpack_public_path__ + "static/19-99270439c450faab6e0ab50c1fc69f45.jpg";